<template>
	<div class="product-field" :class="{ invalid: isInvalid }">
        <div class="mb-2" v-if="isInvalid">
            <span class="error-text">
            {{ $tr.product.fieldRequired }}
        </span>
        </div>

        <template v-if="field.type === 'text'">
            <span class="name before-input">
				{{ field.name }}
				<template v-if="field.id === 'text' && this.selectedProduct && this.selectedProduct.id !== 'none'">
					-
					{{ this.selectedProduct.name }}
				</template>
			</span>
        </template>
        <template v-else>
            <span class="name">{{ field.name }}</span>
        </template>

		<RadioSelect v-if="field.type === 'select'" :values="field.values" :name="field.id" :value="fieldValue" @input="saveOption"/>
		<span v-else-if="field.type === 'text'" class="input-container">
			<input type="text" :value="fieldValue" @input="saveOption">
		</span>
	</div>
</template>

<script>
	import RadioSelect from "../common/RadioSelect";
	import { EventBus } from "../../event-bus";

	export default {
		name: "ProductField",
		components: {
			RadioSelect
		},
		props: [
			"field",
			"productId",
			"required"
		],
		computed: {
			fieldValue() {
				return this.$db.products[this.productId + "-" + this.field.id];
			},
			isInvalid() {
				return this.required && (!this.fieldValue || (typeof this.fieldValue === "string" && !this.fieldValue.trim()));
			},
			selectedProduct() {
				return this.$db.products[this.productId];
			}
		},
		mounted() {
			EventBus.$emit("invalid-more-fields", this.productId + "-" + this.field.id, this.isInvalid);
		},
		destroyed() {
			EventBus.$emit("invalid-more-fields", this.productId + "-" + this.field.id, false);
		},
		methods: {
			saveOption(value) {
				if (this.field.type === "text")
					value = value.target.value;

				this.$set(this.$db.products, this.productId + "-" + this.field.id, value);
			}
		},
		watch: {
			isInvalid(value) {
				EventBus.$emit("invalid-more-fields", this.productId + "-" + this.field.id, value);
			}
		}
	}
</script>
